import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  HireDotNetExtensive,
  HireDotNetCertified,
  HireDotNetCustomized,
  HireDotNetSeamless,
  HireDotNetTimely,
  HireDotNetSupport,
} from "../../../app-constants";

function Whychoosespeeech() {
  return (
    <section
      className="voice_services why_choose_speech p-100"
      style={{ background: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Our Framework for Custom App Store Optimization Solutions </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>Your big idea and high-performance app may struggle to top the charts if launched impulsively. App store optimization is just as crucial as your core product features—it ensures your app ranks in top, relevant searches, and drives more downloads. With a proven organic growth framework, our app store optimization agency helps businesses safely launch and effectively scale mobile applications across app marketplaces.</p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Customized ASO Strategy</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>We execute a targeted ASO plan to enhance visibility and drive higher conversion rates in app stores.</p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Keyword Optimization  </h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                    We identify and target high-performing keywords to boost the app's visibility and attract relevant traffic.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    
                    <div className="voice_service_head ms-0">
                      <h5>Metadata Enhancement</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                    We optimize titles, descriptions, and tags to improve rankings and drive more downloads.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    
                    <div className="voice_service_head ms-0">
                      <h5>A/B Testing for UI/UX</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                    We refine visual elements and interface design to enhance user engagement and retention.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Localized Listings</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                    We localize app store listings to increase downloads across diverse global markets.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Performance Monitoring</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                    We track performance continuously for search algorithm adaptation and to maintain a competitive edge.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosespeeech;
